import { useQuery } from "@tanstack/react-query";
import { endOfYear, startOfYear } from "date-fns";
import { gqlQuery, toAWSDate } from "../../lib";
import { BankHoliday, Country } from "../../API";

export const useBankHolidayQuery = (
  dates: Interval | null,
  country: Country | ""
) => {
  const dateFilter = {
    between: [
      toAWSDate(new Date(dates?.start ?? startOfYear(new Date()))),
      toAWSDate(new Date(dates?.end ?? endOfYear(new Date()))),
    ],
  };

  const {
    data,
    isLoading,
    isFetching,
    isPreviousData,
    error,
    isError,
    refetch,
    ...rest
  } = useQuery(
    gqlQuery({
      req: "listBankHolidays",
      vars: {
        filter: country
          ? {
              countryCode: { eq: country },
              date: dateFilter,
            }
          : {
              date: dateFilter,
            },
      },
      key: [
        country ?? "",
        dates?.start ?? new Date(),
        dates?.end ?? new Date(),
      ],
    })
  );

  const items = (data?.data?.listBankHolidays?.items ?? []) as BankHoliday[];

  return {
    items,
    count: items.length,
    isPending: isLoading || isPreviousData || isFetching,
    error: error as Error,
    isError,
    refetch,
    ...rest,
  };
};
